import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-check-measurements-products',
  templateUrl: './check-measurements-products.component.html',
  styleUrls: ['./check-measurements-products.component.scss']
})
export class CheckMeasurementsProductsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
